import Address from "./Address";
import Offer from "./Offer";
import { Container } from "./styled";
import ContentSection from "./ContentSection";
import Gallery from "../Gallery";
import { cruiseImages } from "./Cruises/images/cruiseImages";
import { housesImages } from "./Houses/images/housesImages";
import BikeRental from "../Content/Bikes/BikeRental";
import { bikesImages } from "./Bikes/images/bikesImages";
import cruiseImage from "../Content/Cruises/images/cruise.webp";
import houseImage from "../Content/Houses/images/domek.webp";
import bikeImage from "../Content/Bikes/images/bikes.webp";
import PriceTable from "./PriceTable";

const Content = () => {
    return (
        <Container>
            <Offer />
            <ContentSection id="cruises" variant="cruises" imageSrc={cruiseImage} />
            <PriceTable variant="cruises" />
            <Gallery images={cruiseImages} variant="cruises" />
            <ContentSection id="houses" variant="houses" imageSrc={houseImage} />
            <Gallery images={housesImages} variant="houses" />
            <ContentSection id="bikes" variant="bikes" imageSrc={bikeImage} />
            <BikeRental />
            <PriceTable variant="bikesRental" />
            <Gallery images={bikesImages} variant="bikes" />
            <Address />
        </ Container>
    );
};

export default Content;